module.exports = __webpack_public_path__ + "static/media/transfer.c8f6ea07.svg";